import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CharacterPipe } from '../../../pipes/character.pipe';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'calsoft-button-category',
  imports: [MatButton, CharacterPipe],
  templateUrl: './button-category.component.html',
  styleUrl: './button-category.component.scss'
})
export class ButtonCategoryComponent {

   constructor(public dialog: MatDialog,
    private router: Router,){


   }

  @Input() menuData: any;

  @Input() data: any;

  
  open(){

    if(this.menuData.description=='0'){

      this.openMatDialog();

    }else{

      this.link(this.menuData.metaDescription)

    }
  }

  link(url: any) {
    this.router.navigate([url]);
  }
  


  openMatDialog() {
  //   if (window.innerWidth > 768) {

  //     let dialogRef = this.dialog.open(ButtonDialogComponent, {
  //       width: '790px',
  //       data: { value: this.menuData }
  //     });

  //     dialogRef.disableClose = true;
  //     dialogRef.afterClosed().subscribe(result => {
       


  //     });

  //   }
  //   else {
  //     let dialogRef = this.dialog.open(ButtonDialogComponent, {
  //       minWidth: '100vw', height: '100vh',
  //       data: { page: this.menuData, }
  //     });

  //     dialogRef.disableClose = true;
  //     dialogRef.afterClosed().subscribe(result => {
  


  //     });
  //   }

  // }
 }
}